<template>
  <div id="invoice-details" class="detail-page">
    <div v-if="isBusy" class="d-flex align-items-center justify-content-center">
      <loading-spinner />
    </div>
    <div v-else-if="notFound">
      <invoice-not-found :invoice-source="invoiceSource" :invoice-id="invoiceId" />
    </div>
    <div v-else-if="showShippingDetails">      
      <b-container>
        <lanter-shipping-detail 
          :lanter-shipping-details="shippingDetails"
          :invoice-number="invoiceNumber"
          :invoice-id="invoiceId"
          @return="ReturnFromDetails"
        />
      </b-container>
    </div>
    <div v-else class="container invoice-details__content">
      <!-- <b-button
        v-if="IsMcfe && mlePrintEnabled()"
        @click="print"
        class="btn-print pull-right hide-on-print"
        name="format" 
        :value="'PDF'" 
        variant="warning"
      >
        {{ getContentItem("exportAsPDF") }}
      </b-button> -->
      <invoice-details-header 
        :data="getHeaderDetail()" 
        @showLanterDetails="ShowShippingDetails"
      />
      <invoice-details-grid :details="getGridDetail()" :related-orders="getRelatedOrders()" />
      <related-orders :related-orders="getRelatedOrders()" />
    </div>
    <div v-if="!isBusy && IsMcfe" class="container mle-print">
      <mle-print-header 
        :data="getHeaderDetail()"
      />
      <mle-invoice-details-header :data="getHeaderDetail()" />
      <mle-invoice-details-grid :details="getGridDetail()" :related-orders="getRelatedOrders()" />
      <mle-country-of-origin-summary :invoice-details="getGridDetail()" />
      <mle-harmonized-code-summary :invoice-details="getGridDetail()" />
      <mle-container-summary :details="getGridDetail()" />
      <mle-print-footer />
      <related-orders :related-orders="getRelatedOrders()" class="hide-on-print"/>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import $ from "jquery"
  import { constants }           from "@/const"

  import { ErrorLogService, InvoiceService } from "@/services";
  import { FeatureFlagService } from "@/services/FeatureFlagService"

  import { LoadingSpinner } from "@/components/Elements";

  import InvoiceDetailsHeader from "./InvoiceDetailsHeader";
  import InvoiceDetailsGrid from "./InvoiceDetailsGrid";
  import InvoiceNotFound from "./InvoiceNotFound";
  import RelatedOrders from "./RelatedOrders";
  import { LanterShippingDetail } from "@/components/Logistics";

  //MLE Print Components
  import MleInvoiceDetailsHeader from "./MLE/MleInvoiceDetails/MleInvoiceDetailsHeader.vue"
  import MleInvoiceDetailsGrid from "./MLE/MleInvoiceDetails/MleInvoiceDetailsGrid.vue"
  import MleContainerSummary from "./MLE/MleContainerSummary/MleContainerSummary.vue"
  import MleHarmonizedCodeSummary from "./MLE/MleHarmonizedCodeSummary/MleHarmonizedCodeSummary.vue"
  import MleCountryOfOriginSummary from "./MLE/MleCountryOfOriginSummary/MleCountryOfOriginSummary.vue"
  import MlePrintHeader from "./MLE/MleHeaderAndFooter/MlePrintHeader.vue"
  import MlePrintFooter from "./MLE/MleHeaderAndFooter/MlePrintFooter.vue"



  export default {
    name: "InvoiceDetails",
    components: {
      InvoiceDetailsHeader,
      InvoiceDetailsGrid,
      MleInvoiceDetailsHeader,
      MleInvoiceDetailsGrid,
      InvoiceNotFound,
      RelatedOrders,
      LoadingSpinner,
      LanterShippingDetail,
      MleContainerSummary,
      MleHarmonizedCodeSummary,
      MleCountryOfOriginSummary,
      MlePrintHeader,
      MlePrintFooter,
    },
    props: {
      invoiceId: {},
      invoiceSource: {
        type: String,
        required: true
      }
    },
    data: () => ({
      InvoiceDetails: null,
      isBusy: true,
      notFound: false,
      showShippingDetails: false,
      shippingDetails: [],
      invoiceNumber: ""
    }),
    computed: {
      ...mapGetters([
        "user",
        "getContentItem",
        "hasPermission",
        "canSeeAnyPrice",
        "availableDealerCodes",
        "activeAccountId",
        "IsMcfe",
        "McfCostCenterId"
      ])
    },
    mounted() {
      this.fetchInvoiceDetails();
    },
    methods: {
      fetchInvoiceDetails: function() {
        return InvoiceService.GetInvoiceDetail(
          this.activeAccountId,
          this.user.UserId,
          this.invoiceId,
          this.invoiceSource
        )
          .then(results => {
            this.InvoiceDetails = results.data;
          })
          .catch(err => {
            ErrorLogService.LogException(err);
          })
          .then(() => {
            this.isBusy = false;
            if (!this.InvoiceDetails) {
              this.notFound = true;
            }
          });
      },

      getHeaderDetail: function() {
        const isRapidPartsInvoice =
          this.InvoiceDetails.InvoiceSource === "Rapidparts";
        return {
          ...this.InvoiceDetails,
          userId: this.user.UserId,
          accountId: this.activeAccountId,
          exportAction: InvoiceService.getExportAction(),
          isRapidPartsInvoice,
          isNotRapidPartsInvoice: !isRapidPartsInvoice
        };
      },

      getGridDetail: function() {
        const isRapidPartsInvoice =
          this.InvoiceDetails.InvoiceSource === "Rapidparts";

        return {
          ...this.InvoiceDetails,
          isRapidPartsInvoice,
          isNotRapidPartsInvoice: !isRapidPartsInvoice,
          showPrices: this.canSeeAnyPrice && !this.hasPermission("HideInvoicePricing"),
          showTotal: !this.hasPermission("HideInvoicePricing")
        };
      },

      getRelatedOrders: function() {
        return this.InvoiceDetails.RelatedOrders;
      },
      print(){
        window.print();
      },
      mlePrintEnabled(){
        return FeatureFlagService.IsFeatureFlagEnabled(constants.MLE_INVOICE_PRINTING,this.McfCostCenterId);
      },
      ShowShippingDetails(details, invoiceNumber, invoiceId) {       
        this.shippingDetails = details;        
        this.invoiceNumber = invoiceNumber;
        this.invoiceId = invoiceId
        this.showShippingDetails = true;
      },
      ReturnFromDetails(){
        this.showShippingDetails = false;
      },
    }
  };
</script>

<style lang="scss">
#invoice-details {
  .btn-print {
    margin-left: 1rem;
  }
}
</style>

